import { Link, useParams } from "react-router-dom";
import { CheckCircle, Package, ArrowRight } from "lucide-react";

export const OrderConfirmationPage = () => {
  const { orderId } = useParams();

  return (
    <div className="min-h-screen flex items-center justify-center py-16 animate-fade-in">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-100 flex items-center justify-center">
          <CheckCircle className="w-10 h-10 text-green-600" />
        </div>

        <h1 className="font-serif text-3xl font-semibold text-stone-900 mb-4">
          Thank You for Your Order!
        </h1>

        <p className="font-sans text-stone-600 mb-6">
          Your order has been received and is being processed. You will receive a confirmation email shortly.
        </p>

        <div className="bg-bone-cream p-6 rounded-lg mb-8">
          <div className="flex items-center justify-center gap-2 mb-2">
            <Package className="w-5 h-5 text-deep-moss" />
            <span className="font-sans text-sm text-stone-600">Order ID</span>
          </div>
          <p className="font-mono text-sm text-stone-900 break-all" data-testid="order-id">
            {orderId}
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to="/shop"
            data-testid="continue-shopping-btn"
            className="flex items-center justify-center gap-2 w-full bg-deep-moss hover:bg-deep-moss/90 text-white rounded-full px-6 py-3 font-sans font-medium transition-colors"
          >
            Continue Shopping
            <ArrowRight className="w-4 h-4" />
          </Link>

          <Link
            to="/contact"
            data-testid="contact-support-link"
            className="block text-deep-moss font-sans text-sm hover:underline"
          >
            Have questions? Contact us
          </Link>
        </div>
      </div>
    </div>
  );
};
